export const isEmpty = (obj): boolean =>
  [Object, Array].includes((obj || {}).constructor) &&
  !Object.entries(obj || {}).length

export const omitKeys = (
  obj: Record<string, any>,
  keysToOmit: string | string[],
): Record<string, any> => {
  return Object.keys(obj).reduce(
    (result, key) => {
      if (!keysToOmit.includes(key)) {
        result[key] = obj[key]
      }
      return result
    },
    {} as Record<string, any>,
  )
}

export const invertKeyValue = (
  obj: Record<string, any>,
): Record<string, string> => {
  return Object.keys(obj).reduce(
    (result, key) => {
      const value = obj[key]
      result[value] = key
      return result
    },
    {} as Record<string, string>,
  )
}
